module.exports = __webpack_public_path__ + "img/logo-db1.fd0cef49.svg";